import { createFileRoute } from '@tanstack/react-router'
import { KeyRound } from 'lucide-react'
import { AccessScreen } from '@/screens/me/SCR-121-access'

export const Route = createFileRoute('/_app/me/access')({
  staticData: { screen: { id: 'SCR-121', title: 'Apps with access', group: 'Me', order: 3, eyebrow: 'Who can act for you', description: 'Agents, tokens and products that can act on your memory.', icon: KeyRound } },
  component: AccessScreen,
})
